import Image from "@tiptap/extension-image"
import { Plugin, PluginKey } from "@tiptap/pm/state"

export function uploadImage(file) {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append("file", file)

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/uploads", {
      method: "POST",
      headers: { "X-CSRF-Token": csrfToken },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => resolve(data.url))
      .catch(reject)
  })
}

function handleImageFiles(editor, files) {
  for (const file of files) {
    if (!file.type.startsWith("image/")) continue

    uploadImage(file).then((url) => {
      editor
        .chain()
        .focus()
        .setImage({ src: url, alt: file.name })
        .run()
    })
  }
}

export function createImageExtension() {
  return Image.extend({
    addProseMirrorPlugins() {
      const editor = this.editor

      return [
        new Plugin({
          key: new PluginKey("imageUpload"),
          props: {
            handleDrop(view, event) {
              const files = event.dataTransfer?.files
              if (!files?.length) return false

              const images = Array.from(files).filter((f) =>
                f.type.startsWith("image/")
              )
              if (!images.length) return false

              event.preventDefault()
              handleImageFiles(editor, images)
              return true
            },

            handlePaste(view, event) {
              const files = event.clipboardData?.files
              if (!files?.length) return false

              const images = Array.from(files).filter((f) =>
                f.type.startsWith("image/")
              )
              if (!images.length) return false

              event.preventDefault()
              handleImageFiles(editor, images)
              return true
            },
          },
        }),
      ]
    },
  })
}
